import React from 'react';
import Profile from './Profile';

export default Profile;